import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { ApplicationState } from 'store'
import { PUSH_TOAST, SHIFT_TOAST, Toast, ToastActionTypes } from "./types"

export const pushToastInternal = (toast: Toast): ToastActionTypes => {
	return {
		type: PUSH_TOAST,
		payload: toast
	}
}

export const shiftToast = (): ToastActionTypes => {
	return {
		type: SHIFT_TOAST
	}
}

export const pushToast = (
	toast: Toast
): ThunkAction<Promise<void>, ApplicationState, null, Action<string>> => async (dispatch, getState): Promise<void> => {
	dispatch(pushToastInternal(toast))
	setTimeout(() => dispatch(shiftToast()), getState().toast.timeout)
}
